import React, { useState, useEffect, useRef } from 'react';
import Card from '../common/Card';
import MiniLoader from '../common/MiniLoader';
import { useContracts } from '../../hooks/useContract';
import { formatUsdt } from '../../utils/format';

const AdminStats = () => {
  const { storage } = useContracts();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const runIdRef = useRef(0);

  const load = async () => {
    const myRun = ++runIdRef.current;
    setLoading(true);
    try {
      const s = await storage.getStats();
      if (myRun !== runIdRef.current) return;
      setStats({
        totalUsers: s[0].toNumber ? s[0].toNumber() : Number(s[0]),
        totalInvestment: s[1],
        todayUsers: s[2].toNumber ? s[2].toNumber() : Number(s[2]),
        todayInvestment: s[3],
        routerPool: s[4]
      });
    } catch (_) { /* ignore */ }
    finally {
      if (myRun === runIdRef.current) setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, []);

  if (loading && !stats) {
    return (
      <Card title="Platform Stats">
        <div className="text-center" style={{ padding: 30 }}><MiniLoader /></div>
      </Card>
    );
  }

  return (
    <Card title="Platform Stats" subtitle="Global metrics" glow>
      <div className="grid grid-2 gap-md">
        <div className="stat">
          <span className="stat-label">Total Users</span>
          <span className="stat-value-lg">{stats?.totalUsers.toLocaleString() || '0'}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Today's Users</span>
          <span className="stat-value">{stats?.todayUsers || 0}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Total Investment</span>
          <span className="stat-value-lg">{formatUsdt(stats?.totalInvestment)}<span className="stat-unit">USDT</span></span>
        </div>
        <div className="stat">
          <span className="stat-label">Today's Investment</span>
          <span className="stat-value">{formatUsdt(stats?.todayInvestment)}<span className="stat-unit">USDT</span></span>
        </div>
      </div>
    </Card>
  );
};

export default AdminStats;
